import { compact } from 'lodash-es';

const SITE_URL = 'https://www.edmunds.com';

export const getNonAmpUrl = pathname => pathname && pathname.replace(/(\/)amp\/|^amp\//, '$1');

/**
 * https://web.dev/articles/text-fragments
 */
export function withTargetText(url, { hash = '', prefix, text, suffix }) {
  const targetText = compact([
    prefix && `${encodeURIComponent(prefix)}-`,
    encodeURIComponent(text).replaceAll('-', '%2D'), // dash is reserved symbol for prefix and suffix
    suffix && `-${encodeURIComponent(suffix)}`,
  ]);

  return `${url}#${hash}:~:text=${targetText}`;
}

export function addQueryParam(url, name, value) {
  const urlObj = new URL(url, SITE_URL);
  urlObj.searchParams.set(name, value);

  return urlObj.href.replace(SITE_URL, '');
}

export function removeQueryParam(url, name, value) {
  const urlObj = new URL(url, SITE_URL);
  urlObj.searchParams.delete(name, value);

  return urlObj.href.replace(SITE_URL, '');
}
